import { FormContainer } from 'react-hook-form-mui';
import { SendMessageBlockFields } from 'view/pages/messenger/components';
import { useSendMessage } from 'view/pages/messenger/hooks/useSendMessage';
import * as S from './styled';

const ChatMessagesFooter = ({ chatInfoData, getChatsList }) => {
  const { sendMessage } = useSendMessage(getChatsList);

  const onSubmit = (formData) => {
    sendMessage({ text: formData.message, conversationId: chatInfoData?.id });
  };

  const defaultValues = {
    message: '',
  };

  return (
    <S.ChatMessagesFooter>
      {chatInfoData?.status?.name !== 'Active' ? (
        <S.ChatMessagesFooterNonActiveText>
          {chatInfoData?.status?.description}
        </S.ChatMessagesFooterNonActiveText>
      ) : (
        <FormContainer
          key={JSON.stringify(defaultValues)}
          defaultValues={defaultValues}
          onSuccess={onSubmit}
        >
          <SendMessageBlockFields onSubmit={onSubmit} />
        </FormContainer>
      )}
    </S.ChatMessagesFooter>
  );
};

export default ChatMessagesFooter;
